/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import PlainChartDataToGroupTransformer from '../plain-chartdata-to-group-transformer/plain-chartdata-to-group-transformer';

class PlainChartDataToGroupToHighchartsTransformer extends PlainChartDataToGroupTransformer {
  /*
   * Transforms/Groups a datastructure like this
   *
   * [
   *  {
   *      name: 1,
   *      values: [
   *          [x, x],
   *          [x, x]
   *      ]
   *  },
   *  {
   *      name: 2,
   *      values: [
   *          [x, x],
   *          [x, x],
   *          [x, x]
   *      ]
   *  }
   * ]
   *
   * into this
   *
   * [{
   *    name: '...',
   *    data: [[x,y],[x,y]]
   *  }, ...]
   *
   */


  transform(data, options) {
    const groupedData = super.transform(data, options);

    const highchartsOptions = {
      series: {
        data: groupedData.map((ob, index) => {
          const item = {};
          options.seriesItemDataMapping.forEach(mapping => item[mapping.dest] = this.resolveKeyPath(ob, mapping.src));

          if (options.drilldown) {
            item.drilldown = `${index + 1}`;
          }

          return item;
        }),
      },
    };

    if (options.drilldown) {
      highchartsOptions.drilldown = {
        series: groupedData.map((ob, index) => ({
          id: `${index + 1}`,
          name: ob.name,
          keys: options.valueKeys,
          data: ob.values.map((val) => {
            options.valueKeys.forEach((key, j) => {
              if (['x', 'y', 'z'].indexOf(key) > -1) {
                val[j] = this.forceFloat(val[j]);
              }
            });

            const nameProp = options.seriesItemDataMapping.find(d => d.dest === 'name')?.src;
            const xProp = options.seriesItemDataMapping.find(d => d.dest === 'x')?.src;
            const yProp = options.seriesItemDataMapping.find(d => d.dest === 'y')?.src;

            return {
              name: val[nameProp || 0], x: val[xProp || 1], y: val[yProp || 2], z: 0,
            };
          }),
        })),
      };
    }


    return [highchartsOptions];
  }
}

export default PlainChartDataToGroupToHighchartsTransformer;
